'use strict';

import perflibLoader from '../../src/frontend/core/perflibLoader';
perflibLoader();



// WEBPACK FOOTER //
// ./core/frontend/perflibloader.js